// Pages
import PageHome from '@/views/PageHome';
import PageLogin from '@/views/PageLogin';
import PageForgotPassword from '@/views/PageForgotPassword';
import PageResetPassword from '@/views/PageResetPassword';
import PageRegister from '@/views/PageRegister';
import Page404 from '@/views/Page404';

import PageDuel from '@/views/PageDuel';

// Layout components
import SiteHeader from '@/components/common/SiteHeader';
import SimpleHeader from '@/components/common/SimpleHeader';

export default [
  {
    path: '/index.html',
    name: 'home',
    alias: '/',
    components: {
      default: PageHome,
      header: SimpleHeader,
    },
    meta: {
      bodyClass: 'page-auth page-home',
    },
  },
  {
    path: '/games',
    components: {
      default: () =>
        import(/* webpackChunkName: "auth" */ '@/views/PageGamesWrapper'),
      header: SiteHeader,
    },
    meta: {
      requiresAuth: true,
      bodyClass: 'page-games-wrapper',
    },
    children: [
      {
        name: 'games',
        path: '',
        component: () =>
          import(/* webpackChunkName: "auth" */ '@/views/PageGames'),
        meta: {
          bodyClass: 'page-games',
        },
      },
      {
        name: 'game',
        path: ':id',
        component: () =>
          import(/* webpackChunkName: "auth" */ '@/views/PageGame'),
        meta: {
          bodyClass: 'page-game',
        },
      },
      {
        name: 'duel',
        path: ':id/duels/:duelId',
        component: PageDuel,
        meta: {
          bodyClass: 'page-duel',
        },
      },
    ],
  },
  {
    path: '/login',
    name: 'login',
    components: {
      default: PageLogin,
      header: SimpleHeader,
    },
    meta: {
      bodyClass: 'page-auth page-login',
    },
  },
  {
    path: '/forgotpassword',
    name: 'forgot-password',
    components: {
      default: PageForgotPassword,
      header: SimpleHeader,
    },
    meta: {
      bodyClass: 'page-auth page-forgot-password',
    },
  },
  {
    path: '/reset/:key',
    name: 'reset-password',
    components: {
      default: PageResetPassword,
      header: SimpleHeader,
    },
    meta: {
      bodyClass: 'page-auth page-reset-password',
    },
  },
  {
    name: 'register',
    path: '/register',
    components: {
      default: PageRegister,
      header: SimpleHeader,
    },
    meta: {
      bodyClass: 'page-auth page-register',
    },
  },
  {
    name: 'profile',
    path: '/profile',
    components: {
      default: () =>
        import(/* webpackChunkName: "auth" */ '@/views/PageProfile'),
      header: SiteHeader,
    },
    meta: {
      bodyClass: 'page-profile',
      requiresAuth: true,
    },
  },
  /* Not Found */
  {
    path: '/404',
    name: '404',
    component: Page404,
  },
  /* Default */
  {
    path: '*',
    name: 'default',
    redirect: '/404',
  },
];
